// N.B. Remember to create the ID below.
export enum EXPERIMENT_NAMES {
  PLACEHOLDER_AB_TEST_NAME = 'PLACEHOLDER_AB_TEST_NAME',
  LUNIK_ABC_DE = 'cux_3882_dp_lunik_3_1_vs_manual_ranking_de',
  LUNIK_ABC_DK = 'cux_3668_lunik_vs_manual_manageable_DK',
  LUNIK_ABC_NL = 'cux_3671_lunik_vs_manual_manageable_NL',
  LUNIK_ABC_SK = 'cux_3676_lunik_vs_manual_manageable_SK',
  HYBID_SEARCH = 'cux_3524_TSX_HO_hybrid_map_search',
  TAXES_INCLUDED_DP_UK_DOUBLE_PRICING = 'cux_3763_TSX_DP_DMCC_Include_Taxes_Double_Pricing',
  EVO_RESULT_PAGE_WITH_APEX = 'cux_3886_dp_evo_apex_on_results_v1',
  EVO_RESULT_AND_DETAIL_PAGES_WITH_APEX = 'cux_4035_dp_evo_apex_with_calendar_on_details',
  EVO_TRAIN_HOTEL = 'cux_4063_dp_evo_train_hotel',
  CUX_3966_KIDS_STAY_FREE_OFFERS = 'cux_3966_dp_ho_displaying_only_kids_stay_for_free_offers_on_details',
  APP_SHOW_CSW = 'cux_4024_csw_in_the_app_webview',
  PRICE_TOGGLER = 'cux_4027_dp_evolution_price_toggler',
  FLIGHT_PAGE_CTA_COPY = 'cux_4062_dp_evo_flight_page_cta_copy',
  EVO_HOTEL_ONLY = 'cux_4064_dp_evo_hotel_only',
  FLEXIBLE_SEARCH_ON_APEX_RESULTS = 'cux_4065_flexible_search_on_apex_result_page',
  HO_NO_FREE_CANCELLATION_ON_RESULTS = 'cux_4082_ho_removal_of_free_cancellation_on_result_page',
  LUNIK_BUCKETING_ABC_ES = 'cux_4092_dp_es_lunik_bucketing_abc_on_manageable_destinations',
  LUNIK_BUCKETING_ABC_IT = 'cux_4093_dp_it_lunik_bucketing_abc_on_manageable_destinations',
  LUNIK_BUCKETING_ABC_FR = 'cux_4094_dp_fr_lunik_bucketing_abc_on_manageable_destinations_outside_apex_perim',
  LUNIK_BUCKETING_ABC_DE = 'cux_4095_dp_de_lunik_bucketing_abc_on_manageable_destinations_outside_apex_perim',
  EVO_FILTERS = 'cux_4021_dp_evo_filters',
}

// The four surviving Lunik-vs-manual-ranking tests. Every consumer treats them alike — same SAAB
// perimeter, same ranking and RTCO effect per arm — so they are listed once here and the next one
// to finish is a single-line delete.
export const LUNIK_ABC_EXPERIMENTS = [
  EXPERIMENT_NAMES.LUNIK_ABC_DE,
  EXPERIMENT_NAMES.LUNIK_ABC_DK,
  EXPERIMENT_NAMES.LUNIK_ABC_NL,
  EXPERIMENT_NAMES.LUNIK_ABC_SK,
] as const;

// SAAB owns their market, mode and APEX perimeters, and since MPH-1172 their RTCO configuration too
// - which is what retired the strategy 1 / strategy 2 split this list used to be built from. TSX
// only needs to know which of them a search was allocated to.
export const LUNIK_BUCKETING_ABC_EXPERIMENTS = [
  EXPERIMENT_NAMES.LUNIK_BUCKETING_ABC_ES,
  EXPERIMENT_NAMES.LUNIK_BUCKETING_ABC_IT,
  EXPERIMENT_NAMES.LUNIK_BUCKETING_ABC_FR,
  EXPERIMENT_NAMES.LUNIK_BUCKETING_ABC_DE,
] as const;
